'use strict';

const { hydrate } = require('@grpn/hydration');
const { Component } = require('phy');

const LeaderboardBanner = require('./leaderboard-banner');

class LeaderboardBannerWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offsetWidth: 0,
      clientHeight: 0,
    };
  }

  componentDidMount() {
    const banner = document.querySelector('.banner-content');

    if (banner) {
      const { offsetWidth, clientHeight } = banner;
      this.setState({
        offsetWidth,
        clientHeight,
      });
    }
  }

  getImageSize({ isTouch, offsetWidth, clientHeight }) {
    if (isTouch) {
      return offsetWidth
        ? `c_fill,w_${offsetWidth},h_${clientHeight}`
        : 'c_fill,w_371,h_156';
    }
    return offsetWidth
      ? `c_fill,w_${offsetWidth},h_100`
      : 'c_fill,w_1056,h_100';
  }

  getCorrectAdvert(adverts) {
    return adverts.find(advert => advert.leaderboard.leaderboardPosition === 1);
  }

  getCorrectImageUrl(medias) {
    return medias.find(media => media.isMainImage === true);
  }

  render() {
    const { show, adverts, isTouch, outerClassName, routes } = this.props;

    if (!show) {
      return null;
    }

    const advert = this.getCorrectAdvert(adverts);

    if (!advert) {
      return null;
    }

    const { offsetWidth, clientHeight } = this.state;
    const { mediaUrl } = this.getCorrectImageUrl(advert.media);
    const size = this.getImageSize({
      isTouch,
      offsetWidth,
      clientHeight,
    });

    return LeaderboardBanner({
      advert,
      imageUrl: mediaUrl.replace('{{options}}', `${size},`),
      outerClassName,
      routes,
    });
  }
}

module.exports = hydrate('LeaderboardBannerWrapper', LeaderboardBannerWrapper);
